// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navigation_swiper-navigation__lS4qT {
  display: flex;
  gap: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Swiper/Navigation/Navigation.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;AACX","sourcesContent":[".swiper-navigation {\n  display: flex;\n  gap: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"swiper-navigation": `Navigation_swiper-navigation__lS4qT`
};
export default ___CSS_LOADER_EXPORT___;
